<div class="password-input-container">
  <div class="password-wrapper">
    <input
      ngxTouchKeyboard
      #touchKeyboard="ngxTouchKeyboard"
      [type]="passwordInfo.isPasswordVisible ? 'text' : 'password'"
      [(ngModel)]="passwordInfo.value"
      class="password-input"
      (input)="checkPassRules(passwordInfo.value)"
      [placeholder]="inputPlaceholder | translate"
      autocomplete="new-password"
    />
    <div class="input-icons">
      @if (passwordInfo.complexityLevel > 0 && displayIndicator) {
        <div class="strength-indicator">
          <span
            class="strength-indicator-text"
            [style]="{ color: passwordInfo.passwordStrengthColor }"
            >{{ passwordInfo.passwordStrengthText | translate }}</span
          >
          <div class="dashes">
            @for (item of [1, 2, 3]; track item; let i = $index) {
              <div
                [style]="{
                  'background-color': passwordInfo.complexityLevel - 1 >= i ? passwordInfo.passwordStrengthColor : '',
                }"
              ></div>
            }
          </div>
        </div>
      }
      <div
        class="toggle-password"
        (click)="togglePasswordVisibility()"
      >
        <img
          class="{{ passwordInfo.isPasswordVisible ? 'eye-icon-open' : 'eye-icon-closed' }}"
          src="{{ passwordInfo.isPasswordVisible ? 'wealth-assets/icons/eye.svg' : 'wealth-assets/icons/eye-closed.svg' }}"
        />
      </div>
      <div
        class="keyboard"
        (click)="touchKeyboard.togglePanel()"
      >
        <img
          class="grid-icon"
          src="wealth-assets/icons/keyboard.svg"
        />
      </div>
    </div>
  </div>
</div>
